import React from "react";
import { Icon } from "@chakra-ui/react";

export const DifficultIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 72 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M49.9259 22.7123V33.5086C47.6855 35.7784 46.3434 37.3058 43.3757 39.8034L42.0086 41.1386C42.0086 41.6676 41.7182 42.0288 41.1822 42.0288L40.6851 42.7283V22.7123C40.6851 20.1634 42.7491 18.0919 45.3055 18.0919C46.5836 18.0919 47.7369 18.6135 48.5743 19.4435C49.4116 20.2809 49.9259 21.4342 49.9259 22.7123Z"
        fill="#CBDAF7"
      />
      <path
        d="M26.1396 19.8408C28.4725 19.8408 30.3634 17.9498 30.3634 15.6171C30.3634 13.2843 28.4725 11.3933 26.1396 11.3933C23.807 11.3933 21.916 13.2843 21.916 15.6171C21.916 17.9498 23.807 19.8408 26.1396 19.8408Z"
        fill="#CBDAF7"
      />
      <path
        d="M31.2676 26.789V42.8026H31.1354V42.2883C27.6022 39.3869 24.5832 36.6322 22.0195 34.0319V26.789C22.0195 24.2401 24.091 22.1686 26.6472 22.1686C27.9253 22.1686 29.0786 22.6901 29.916 23.5202C30.7461 24.3576 31.2676 25.5109 31.2676 26.789Z"
        fill="#CBDAF7"
      />
      <path
        d="M44.9089 16.8431C47.2415 16.8431 49.1325 14.9521 49.1325 12.6194C49.1325 10.2867 47.2415 8.39563 44.9089 8.39563C42.576 8.39563 40.6851 10.2867 40.6851 12.6194C40.6851 14.9521 42.576 16.8431 44.9089 16.8431Z"
        fill="#CBDAF7"
      />
      <path
        d="M25.3396 19.4149C27.8956 19.4149 29.9675 17.3429 29.9675 14.7871C29.9675 12.2312 27.8956 10.1593 25.3396 10.1593C22.7838 10.1593 20.7119 12.2312 20.7119 14.7871C20.7119 17.3429 22.7838 19.4149 25.3396 19.4149Z"
        stroke="#454545"
        strokeWidth="0.620896"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.96 42.1858V25.9814C29.96 24.7033 29.4385 23.55 28.6086 22.7126C27.771 21.8751 26.6179 21.3535 25.3396 21.3535C22.7834 21.3535 20.7119 23.425 20.7119 25.9814V33.2336"
        stroke="#454545"
        strokeWidth="0.620896"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9441 28.3614C33.287 28.3614 34.3755 27.2728 34.3755 25.93C34.3755 24.5871 33.287 23.4985 31.9441 23.4985C30.6013 23.4985 29.5127 24.5871 29.5127 25.93C29.5127 27.2728 30.6013 28.3614 31.9441 28.3614Z"
        fill="#CBDAF7"
      />
      <path
        d="M32.4878 28.6262C34.1308 28.6262 35.4628 27.2943 35.4628 25.6513C35.4628 24.0081 34.1308 22.6761 32.4878 22.6761C30.8447 22.6761 29.5127 24.0081 29.5127 25.6513C29.5127 27.2943 30.8447 28.6262 32.4878 28.6262Z"
        stroke="#454545"
        strokeWidth="0.620896"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.1547 32.6294V43.4536C34.0519 43.5417 32.4439 44.3184 32.3339 44.3991C30.6149 43.099 31.5477 43.5367 30.0272 42.2878L29.4252 41.7399L28.8364 41.0995V32.6294C28.8364 32.3428 28.8806 32.0637 28.9688 31.7993C29.314 30.7342 30.313 29.9702 31.4956 29.9702C32.2301 29.9702 32.8986 30.2713 33.376 30.7489C33.8536 31.2263 34.1547 31.8948 34.1547 32.6294Z"
        fill="#CBDAF7"
      />
      <path
        d="M29.5127 41.8844V32.8565C29.5127 32.2836 29.6743 31.7473 29.9609 31.2919C30.4824 30.4398 31.4153 29.8741 32.4878 29.8741C33.3105 29.8741 34.0523 30.2047 34.596 30.7484C35.1323 31.2919 35.4628 32.0337 35.4628 32.8565V45.5864"
        stroke="#454545"
        strokeWidth="0.620896"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.4447 29.9697C40.0879 29.9697 41.4196 28.6377 41.4196 26.9947C41.4196 25.3515 40.0879 24.0198 38.4447 24.0198C36.8017 24.0198 35.4697 25.3515 35.4697 26.9947C35.4697 28.6377 36.8017 29.9697 38.4447 29.9697Z"
        stroke="#454545"
        strokeWidth="0.620896"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.4193 40.812V34.2009C41.4193 33.3781 41.0888 32.629 40.545 32.0927C40.1337 31.6814 39.6049 31.3876 39.0098 31.2699C38.8262 31.2407 38.6352 31.2185 38.4443 31.2185C36.7988 31.2185 35.4619 32.5554 35.4619 34.2009V45.5866"
        stroke="#454545"
        strokeWidth="0.620896"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.8879 16.5571C46.679 16.5571 48.9416 14.2944 48.9416 11.5033C48.9416 8.71212 46.679 6.44946 43.8879 6.44946C41.0967 6.44946 38.834 8.71212 38.834 11.5033C38.834 14.2944 41.0967 16.5571 43.8879 16.5571Z"
        stroke="#454545"
        strokeWidth="0.620896"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.0103 42.8023V22.9984C39.0103 20.4422 41.0818 18.3781 43.6381 18.3781H44.1303C46.6864 18.3781 48.7579 20.4422 48.7579 22.9984V34.0683"
        stroke="#454545"
        strokeWidth="0.620896"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.0281 34.4284V41.2451C41.0281 41.8622 40.5287 42.369 39.9042 42.369L39.7812 43.1806L38.9683 43.8511L35.7173 43.599V34.421C35.7173 32.9593 36.9073 31.7693 38.369 31.7693C38.8025 31.7693 39.2138 31.8721 39.5737 32.0631C40.4332 32.4966 41.0209 33.3926 41.0209 34.4284H41.0281Z"
        fill="#CBDAF7"
      />
      <path
        d="M38.7569 29.6045C40.0998 29.6045 41.1883 28.4313 41.1883 26.984C41.1883 25.5368 40.0998 24.3634 38.7569 24.3634C37.4143 24.3634 36.3257 25.5368 36.3257 26.984C36.3257 28.4313 37.4143 29.6045 38.7569 29.6045Z"
        fill="#CBDAF7"
      />
      <path
        d="M38.7573 62.7326V49.6901C38.7573 47.5649 39.6014 45.524 41.1051 44.0281L51.0404 34.0927C52.2602 32.8728 54.232 32.8728 55.4518 34.0927C56.6716 35.3125 56.6716 37.2842 55.4518 38.5041L50.9943 42.9617C50.1965 43.7595 50.1965 45.0638 50.9943 45.8616C51.7923 46.6596 53.0887 46.6596 53.8944 45.8616L60.8759 38.9032C62.6943 37.0924 63.7147 34.6297 63.7147 32.0596V23.8504C63.7147 21.8557 65.3336 20.2369 67.3283 20.2369C69.323 20.2369 70.9417 21.8557 70.9417 23.8504V38.6116C70.9417 41.8798 69.5685 44.9948 67.167 47.2119L53.9328 59.3723C53.2423 60.009 52.8433 60.9066 52.8433 61.8427V63.4845H41.9105"
        fill="#D96D46"
      />
      <path
        d="M36.8394 59.7175V49.6901C36.8394 47.5649 37.6834 45.524 39.1871 44.0281L49.1224 34.0927C50.3422 32.8728 52.314 32.8728 53.5338 34.0927C54.7536 35.3125 54.7536 37.2842 53.5338 38.5041L49.0763 42.9617C48.2785 43.7595 48.2785 45.0638 49.0763 45.8616C49.8743 46.6596 51.1708 46.6596 51.9764 45.8616L58.9579 38.9032C60.7763 37.0924 61.7967 34.6297 61.7967 32.0596V23.8504C61.7967 21.8557 63.4154 20.2369 65.4103 20.2369C67.405 20.2369 69.0237 21.8557 69.0237 23.8504V38.6116C69.0237 41.8798 67.6505 44.9948 65.2491 47.2119L52.0148 59.3723C51.3244 60.009 50.9253 60.9066 50.9253 61.8427V63.4845H42.6313"
        stroke="#454545"
        strokeWidth="0.672478"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.1844 63.4845V49.6901C32.1844 47.5649 31.3405 45.524 29.8368 44.0281L19.9013 34.0927C18.6815 32.8728 16.7098 32.8728 15.49 34.0927C14.2701 35.3125 14.2701 37.2842 15.49 38.5041L19.9474 42.9617C20.7454 43.7595 20.7454 45.0638 19.9474 45.8616C19.1496 46.6596 17.853 46.6596 17.0474 45.8616L10.0658 38.9032C8.2475 37.0924 7.22711 34.6297 7.22711 32.0596V23.8504C7.22711 21.8557 5.60829 20.2369 3.61355 20.2369C1.61881 20.2369 0 21.8557 0 23.8504V38.6116C0 41.8798 1.3733 44.9948 3.77466 47.2119L17.009 59.3723C17.6995 60.009 18.0985 60.9066 18.0985 61.8427V63.4845H29.0312"
        fill="#D96D46"
      />
      <path
        d="M34.0945 59.7175V49.6901C34.0945 47.5649 33.2507 45.524 31.747 44.0281L21.8115 34.0927C20.5917 32.8728 18.62 32.8728 17.4001 34.0927C16.1802 35.3125 16.1802 37.2842 17.4001 38.5041L21.8575 42.9617C22.6555 43.7595 22.6555 45.0638 21.8575 45.8616C21.0597 46.6596 19.7631 46.6596 18.9575 45.8616L11.9759 38.9032C10.1577 37.0924 9.13727 34.6297 9.13727 32.0596V23.8504C9.13727 21.8557 7.51845 20.2369 5.52371 20.2369C3.52897 20.2369 1.91016 21.8557 1.91016 23.8504V38.6116C1.91016 41.8798 3.28346 44.9948 5.68482 47.2119L18.9192 59.3723C19.6097 60.009 20.0086 60.9066 20.0086 61.8427V63.4845H29.6218"
        stroke="#454545"
        strokeWidth="0.672478"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
